window.Valence ||= {}
window.Valence.Utils ||= {}

window.Valence.Utils.Events = {
  delegateEventListener(type, targetSelector, listener, delegatedTo = document) {
    delegatedTo.addEventListener(type, (event) => {
      const trigger = event.target
      if (trigger.closest(targetSelector)) {
        listener(event)
      }
    })
  },

  delegate({
    callback,
    eventTarget,
    eventType,
    delegatedTo = document,
  }) {
    delegatedTo.addEventListener(eventType, (event) => {
      const trigger = event.target
      if (trigger.closest(eventTarget)) {
        callback(event)
      }
    })
  },
}
